import React, { useState, useEffect, useRef } from "react";
import * as S from "./styles";
import ArrowDown from '../../../assets/icons/icon-arrow-down-alone-gray.png';
import { TaglineM } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";

const FILTER_KEYS = {
  agronomos: "Responsável Técnico",
  art_trt: "ART/TRT",
  produtores: "Produtor",
  fazendas: "Fazenda/Sítio",
  culturas: "Cultura",
  classes: "Classe",
  pragas: "Praga ou Alvo",
  fabricantes: "Fabricante",
};

const FilterHistory = ({ history, onChange, onBlurFilter, children, startDateValue, endDateValue, isLoading, initialSelectedOptions }) => {
  const [openSelect, setOpenSelect] = useState(null);
  // Permite abrir a tela já com um filtro pré-marcado (ex.: vindo da tela de
  // ARTs/TRT com "Ver receitas emitidas") - só usado como valor inicial, o
  // componente segue dono da própria seleção depois disso.
  const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions || {});
  const [filterOptions, setFilterOptions] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const [selectionChanged, setSelectionChanged] = useState(false);
  const selectRef = useRef(null);
  const [openChildrenSelect, setOpenChildrenSelect] = useState(false);
  const hasDateValues = startDateValue || endDateValue;

  useEffect(() => {
    if (history) {
      const mappedFilters = {};
      
      Object.keys(FILTER_KEYS).forEach((key) => {
        if (history[key]) {
          mappedFilters[FILTER_KEYS[key]] = history[key];
        }
      });
      
    setFilterOptions(mappedFilters);
    }
  }, [history]);
  

  const toggleSelect = (filter) => {
    if (filter !== "data_emissao") {
      setOpenChildrenSelect(false)
    }

    if (openSelect === filter && selectionChanged) {
      if (onBlurFilter) {
        onBlurFilter(selectedOptions, filterOptions);
      }
      
      setSelectionChanged(false);
    }

    const newOpenSelect = openSelect === filter ? null : filter;
    setOpenSelect(newOpenSelect);
  };

  const toggleChildrenSelect = () => {
    setOpenChildrenSelect(!openChildrenSelect);
  };

  const selectOption = (filter, option) => {
    setSelectionChanged(true);

    const optionValue = option.value;

    setSelectedOptions((prev) => {
      const currentSelections = prev[filter] || [];
      const updatedSelections = currentSelections.includes(optionValue)
        ? currentSelections.filter(item => item !== optionValue)
        : [...currentSelections, optionValue];

      return { ...prev, [filter]: updatedSelections };
    });
  };

   useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        if (openSelect && selectionChanged) {
          if (onBlurFilter) {
            onBlurFilter(selectedOptions, filterOptions);
          }
          setSelectionChanged(false);
        }
  
        setOpenSelect(null);
        setOpenChildrenSelect(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openSelect, selectionChanged, onBlurFilter]);

   useEffect(() => {
    if (openSelect === null) {
      setSearchTerm("");
      onChange(selectedOptions);
    }
  }, [openSelect]);  

  const showSkeleton = isLoading && Object.keys(filterOptions).length === 0;

  return (
    <S.Container ref={selectRef}>
      {showSkeleton && Object.values(FILTER_KEYS).map((label) => (
        <S.CustomSelect key={`loading-${label}`}>
          <S.SelectButton selected={false} style={{ opacity: 0.4, cursor: "default", pointerEvents: "none" }}>
            <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800} cursor="default">
              {label}
            </TaglineM>
            <S.Arrow selected={false}>
              <img src={ArrowDown} alt="" style={{ width: "16px", height: "auto" }} />
            </S.Arrow>
          </S.SelectButton>
        </S.CustomSelect>
      ))}

      {!showSkeleton && Object.keys(filterOptions).map((filter) => {
        const isSelected = selectedOptions[filter] && selectedOptions[filter].length > 0;

        return (
          <S.CustomSelect key={filter}>
            <S.SelectButton onClick={() => toggleSelect(filter)} selected={isSelected}>
              <TaglineM color={isSelected ? "#FFF" : theme.colors.gray.Cinza_2} fontWeight={800} cursor="pointer">
                {filter}
              </TaglineM>

              <S.Arrow className={openSelect === filter ? "open" : ""} selected={isSelected}>
                <img src={ArrowDown} alt="Seta Apontada para baixo" style={{ width: "16px", height: "auto" }}/>
              </S.Arrow>
            </S.SelectButton>

            {openSelect === filter && (
              <S.SelectOptions>
                <S.SearchInputContainer>
                  <input
                    type="text"
                    placeholder="Buscar"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </S.SearchInputContainer>
                <S.OptionsList>
                  {filterOptions[filter]
                    .filter((option) => (option?.label || "").toLowerCase().includes((searchTerm || "").toLowerCase()))
                    .map((option, i) => (
                      <S.Option key={`${filter}_${i}`}>
                        <input
                          type="checkbox"
                          checked={selectedOptions[filter]?.includes(option.value) || false}
                          onChange={() => selectOption(filter, option)}
                        />

                        <label onClick={() => selectOption(filter, option)}>
                          {option.label}
                        </label>
                      </S.Option>
                    ))}
                </S.OptionsList>
              </S.SelectOptions>
            )}
          </S.CustomSelect>
        );
      })}

      {children && (
        <S.CustomSelect key={"data_emissao"}>
          <S.SelectButton 
            onClick={() => {
              toggleChildrenSelect();
              toggleSelect("data_emissao");
            }}
            selected={hasDateValues}
          >
            <TaglineM
              color={hasDateValues ? "#FFF" : theme.colors.gray.Cinza_2}
              fontWeight={800}
              cursor="pointer"
            >
              Data de emissão
            </TaglineM>

            <S.Arrow className={openChildrenSelect ? "open" : ""} selected={hasDateValues}>
              <img src={ArrowDown} alt="Seta Apontada para baixo" style={{ width: "16px", height: "auto" }}/>
            </S.Arrow>
          </S.SelectButton>

          {openChildrenSelect && (
            <S.SelectOptions>
              {children}
            </S.SelectOptions>
          )}
        </S.CustomSelect>
      )}
    </S.Container>
  );
};

export default FilterHistory;